import { createAsyncThunk } from '@reduxjs/toolkit';

export const lookupListingsByMasters = createAsyncThunk(
  'products/lookupListingsByMasters',
  async ({ masterProductIds = [] }, {
    extra: { sdk, Logger },
  }) => {
    if (!masterProductIds.length) {
      return { listings: [], listingVariants: [] };
    }

    try {
      const { data } = await sdk.products.listListingsByMasters({ masterProductIds });
      return {
        listings: data?.listings || [],
        listingVariants: data?.listingVariants || [],
      };
    } catch (error) {
      Logger.error(
        error instanceof Error ? error : new Error('Bulk listing lookup failed'),
        { error, masterCount: masterProductIds.length },
        ['LookupListingsByMastersFailed', { masterCount: masterProductIds.length }],
      );
      throw error;
    }
  },
);
